
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[gameRoom]",
      function () {
        return require("private-next-pages/[gameRoom].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[gameRoom]"])
      });
    }
  